import React, { useMemo, useState } from "react";
import {
    Search,
    Filter,
    Eye,
    X,
    ChevronDown,
    RotateCcw,
    CreditCard,
    CheckCircle,
    Clock,
    XCircle,
    RefreshCcw,
} from "lucide-react";

const initialPayments = [
    {
        id: 1,
        paymentId: "PAY10001",
        memberId: "JP10001",
        memberName: "Arun Kumar",
        mobile: "9876543210",
        branch: "Erode Main Branch",
        plan: "Premium",
        amount: 2499,
        discount: 250,
        gst: 404.82,
        totalAmount: 2653.82,
        paymentMethod: "UPI",
        gateway: "Razorpay",
        transactionId: "pay_RZP100001",
        paymentDate: "2026-10-05",
        paymentTime: "10:30 AM",
        status: "Success",
    },
    {
        id: 2,
        paymentId: "PAY10002",
        memberId: "JP10002",
        memberName: "Priya Devi",
        mobile: "9876543211",
        branch: "Coimbatore Branch",
        plan: "Basic",
        amount: 999,
        discount: 100,
        gst: 161.82,
        totalAmount: 1060.82,
        paymentMethod: "Credit Card",
        gateway: "Razorpay",
        transactionId: "pay_RZP100002",
        paymentDate: "2026-10-05",
        paymentTime: "11:15 AM",
        status: "Success",
    },
    {
        id: 3,
        paymentId: "PAY10003",
        memberId: "JP10003",
        memberName: "Suresh Kumar",
        mobile: "9876543212",
        branch: "Salem Branch",
        plan: "Gold",
        amount: 4999,
        discount: 500,
        gst: 809.82,
        totalAmount: 5308.82,
        paymentMethod: "Net Banking",
        gateway: "Razorpay",
        transactionId: "pay_RZP100003",
        paymentDate: "2026-10-04",
        paymentTime: "04:20 PM",
        status: "Pending",
    },
    {
        id: 4,
        paymentId: "PAY10004",
        memberId: "JP10004",
        memberName: "Kavitha R",
        mobile: "9876543213",
        branch: "Tiruppur Branch",
        plan: "Basic",
        amount: 999,
        discount: 0,
        gst: 179.82,
        totalAmount: 1178.82,
        paymentMethod: "Debit Card",
        gateway: "Razorpay",
        transactionId: "pay_RZP100004",
        paymentDate: "2026-10-04",
        paymentTime: "02:45 PM",
        status: "Failed",
    },
    {
        id: 5,
        paymentId: "PAY10005",
        memberId: "JP10005",
        memberName: "Vignesh M",
        mobile: "9876543214",
        branch: "Erode Main Branch",
        plan: "Premium",
        amount: 2499,
        discount: 250,
        gst: 404.82,
        totalAmount: 2653.82,
        paymentMethod: "UPI",
        gateway: "PhonePe",
        transactionId: "PP100005",
        paymentDate: "2026-10-03",
        paymentTime: "09:40 AM",
        status: "Refunded",
    },
    {
        id: 6,
        paymentId: "PAY10006",
        memberId: "JP10006",
        memberName: "Divya S",
        mobile: "9876543215",
        branch: "Coimbatore Branch",
        plan: "Gold",
        amount: 4999,
        discount: 500,
        gst: 809.82,
        totalAmount: 5308.82,
        paymentMethod: "UPI",
        gateway: "Razorpay",
        transactionId: "pay_RZP100006",
        paymentDate: "2026-10-02",
        paymentTime: "01:10 PM",
        status: "Success",
    },
];

const emptyFilters = {
    branch: "",
    plan: "",
    paymentMethod: "",
    status: "",
    gateway: "",
    date: "",
};

function Payments() {
    const [payments] = useState(initialPayments);

    const [searchType, setSearchType] = useState("paymentId");
    const [searchText, setSearchText] = useState("");

    const [filters, setFilters] = useState(emptyFilters);
    const [showFilters, setShowFilters] = useState(true);

    const [viewPayment, setViewPayment] = useState(null);

    const filteredPayments = useMemo(() => {
        return payments.filter((payment) => {
            const searchValue = searchText.toLowerCase().trim();

            let searchMatch = true;

            if (searchValue) {
                if (searchType === "paymentId") {
                    searchMatch = payment.paymentId
                        .toLowerCase()
                        .includes(searchValue);
                }

                if (searchType === "memberId") {
                    searchMatch = payment.memberId
                        .toLowerCase()
                        .includes(searchValue);
                }

                if (searchType === "mobile") {
                    searchMatch = payment.mobile.includes(searchValue);
                }

                if (searchType === "transactionId") {
                    searchMatch = payment.transactionId
                        .toLowerCase()
                        .includes(searchValue);
                }
            }

            const filterMatch =
                (!filters.branch ||
                    payment.branch === filters.branch) &&
                (!filters.plan ||
                    payment.plan === filters.plan) &&
                (!filters.paymentMethod ||
                    payment.paymentMethod === filters.paymentMethod) &&
                (!filters.status ||
                    payment.status === filters.status) &&
                (!filters.gateway ||
                    payment.gateway === filters.gateway) &&
                (!filters.date ||
                    payment.paymentDate === filters.date);

            return searchMatch && filterMatch;
        });
    }, [payments, searchText, searchType, filters]);

    const clearFilters = () => {
        setSearchText("");
        setFilters(emptyFilters);
    };

    const uniqueValues = (key) => {
        return [...new Set(payments.map((item) => item[key]))];
    };

    const totalAmount = payments
        .filter((item) => item.status === "Success")
        .reduce((sum, item) => sum + item.totalAmount, 0);

    const todayAmount = payments
        .filter(
            (item) =>
                item.paymentDate === "2026-10-05" &&
                item.status === "Success"
        )
        .reduce((sum, item) => sum + item.totalAmount, 0);

    const successfulPayments = payments.filter(
        (item) => item.status === "Success"
    ).length;

    const pendingPayments = payments.filter(
        (item) => item.status === "Pending"
    ).length;

    const failedPayments = payments.filter(
        (item) => item.status === "Failed"
    ).length;

    const refundedAmount = payments
        .filter((item) => item.status === "Refunded")
        .reduce((sum, item) => sum + item.totalAmount, 0);

    return (
        <div className="payments-page">

            {/* HEADER */}

            <div className="page-header">
                <div>
                    <h1>Payments</h1>
                    <p>Manage and monitor membership payments</p>
                </div>
            </div>

            {/* SUMMARY */}

            <div className="payment-summary">

                <div className="payment-summary-card">
                    <div className="payment-summary-icon blue">
                        <CreditCard size={20} />
                    </div>

                    <div>
                        <span>Total Payments</span>
                        <strong>
                            ₹{totalAmount.toLocaleString("en-IN", {
                                maximumFractionDigits: 2,
                            })}
                        </strong>
                    </div>
                </div>

                <div className="payment-summary-card">
                    <div className="payment-summary-icon green">
                        <CheckCircle size={20} />
                    </div>

                    <div>
                        <span>Today Payments</span>
                        <strong>
                            ₹{todayAmount.toLocaleString("en-IN", {
                                maximumFractionDigits: 2,
                            })}
                        </strong>
                    </div>
                </div>

                <div className="payment-summary-card">
                    <div className="payment-summary-icon success">
                        <CheckCircle size={20} />
                    </div>

                    <div>
                        <span>Successful</span>
                        <strong>{successfulPayments}</strong>
                    </div>
                </div>

                <div className="payment-summary-card">
                    <div className="payment-summary-icon warning">
                        <Clock size={20} />
                    </div>

                    <div>
                        <span>Pending</span>
                        <strong>{pendingPayments}</strong>
                    </div>
                </div>

                <div className="payment-summary-card">
                    <div className="payment-summary-icon danger">
                        <XCircle size={20} />
                    </div>

                    <div>
                        <span>Failed</span>
                        <strong>{failedPayments}</strong>
                    </div>
                </div>

                <div className="payment-summary-card">
                    <div className="payment-summary-icon purple">
                        <RefreshCcw size={20} />
                    </div>

                    <div>
                        <span>Refunded</span>
                        <strong>
                            ₹{refundedAmount.toLocaleString("en-IN", {
                                maximumFractionDigits: 2,
                            })}
                        </strong>
                    </div>
                </div>

            </div>

            {/* SEARCH & FILTER */}

            <div className="payment-filter-card">

                <div className="payment-search-row">

                    <div className="payment-search-type">
                        <select
                            value={searchType}
                            onChange={(e) =>
                                setSearchType(e.target.value)
                            }
                        >
                            <option value="paymentId">
                                Payment ID
                            </option>

                            <option value="memberId">
                                Member ID
                            </option>

                            <option value="mobile">
                                Mobile Number
                            </option>

                            <option value="transactionId">
                                Transaction ID
                            </option>
                        </select>
                    </div>

                    <div className="payment-search-box">

                        <Search size={18} />

                        <input
                            type="text"
                            placeholder={
                                searchType === "paymentId"
                                    ? "Search Payment ID..."
                                    : searchType === "memberId"
                                    ? "Search Member ID..."
                                    : searchType === "mobile"
                                    ? "Search Mobile Number..."
                                    : "Search Transaction ID..."
                            }
                            value={searchText}
                            onChange={(e) =>
                                setSearchText(e.target.value)
                            }
                        />

                        {searchText && (
                            <button
                                className="payment-search-clear"
                                onClick={() =>
                                    setSearchText("")
                                }
                            >
                                <X size={16} />
                            </button>
                        )}

                    </div>

                    <button
                        className="payment-filter-btn"
                        onClick={() =>
                            setShowFilters(!showFilters)
                        }
                    >
                        <Filter size={17} />
                        Filters
                        <ChevronDown
                            size={16}
                            className={
                                showFilters
                                    ? "rotate-180"
                                    : ""
                            }
                        />
                    </button>

                    <button
                        className="payment-reset-btn"
                        onClick={clearFilters}
                    >
                        <RotateCcw size={16} />
                        Reset
                    </button>

                </div>

                {showFilters && (
                    <div className="payment-filter-grid">

                        <PaymentFilterSelect
                            label="Branch"
                            value={filters.branch}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    branch: value,
                                })
                            }
                            options={uniqueValues("branch")}
                        />

                        <PaymentFilterSelect
                            label="Membership Plan"
                            value={filters.plan}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    plan: value,
                                })
                            }
                            options={uniqueValues("plan")}
                        />

                        <PaymentFilterSelect
                            label="Payment Method"
                            value={filters.paymentMethod}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    paymentMethod: value,
                                })
                            }
                            options={uniqueValues("paymentMethod")}
                        />

                        <PaymentFilterSelect
                            label="Payment Status"
                            value={filters.status}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    status: value,
                                })
                            }
                            options={[
                                "Success",
                                "Pending",
                                "Failed",
                                "Refunded",
                            ]}
                        />

                        <PaymentFilterSelect
                            label="Payment Gateway"
                            value={filters.gateway}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    gateway: value,
                                })
                            }
                            options={uniqueValues("gateway")}
                        />

                        <div className="payment-filter-field">

                            <label>Payment Date</label>

                            <input
                                type="date"
                                value={filters.date}
                                onChange={(e) =>
                                    setFilters({
                                        ...filters,
                                        date: e.target.value,
                                    })
                                }
                            />

                        </div>

                    </div>
                )}

            </div>

            {/* PAYMENT TABLE */}

            <div className="payments-table-card">

                <div className="payment-table-header">

                    <div>
                        <h2>Payment List</h2>

                        <span>
                            Showing {filteredPayments.length} of{" "}
                            {payments.length} payments
                        </span>
                    </div>

                </div>

                <div className="payments-table-wrapper">

                    <table className="payments-table">

                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Payment ID</th>
                                <th>Member ID</th>
                                <th>Member Name</th>
                                <th>Mobile</th>
                                <th>Branch</th>
                                <th>Plan</th>
                                <th>Amount</th>
                                <th>Discount</th>
                                <th>GST</th>
                                <th>Total Amount</th>
                                <th>Payment Method</th>
                                <th>Gateway</th>
                                <th>Transaction ID</th>
                                <th>Date</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>

                            {filteredPayments.length === 0 ? (
                                <tr>
                                    <td
                                        colSpan="17"
                                        className="payment-empty-table"
                                    >
                                        No payments found
                                    </td>
                                </tr>
                            ) : (
                                filteredPayments.map(
                                    (payment, index) => (
                                        <tr key={payment.id}>

                                            <td>{index + 1}</td>

                                            <td>
                                                <span className="payment-id">
                                                    {payment.paymentId}
                                                </span>
                                            </td>

                                            <td>
                                                <span className="payment-member-id">
                                                    {payment.memberId}
                                                </span>
                                            </td>

                                            <td>
                                                <strong>
                                                    {payment.memberName}
                                                </strong>
                                            </td>

                                            <td>
                                                {payment.mobile}
                                            </td>

                                            <td>
                                                {payment.branch}
                                            </td>

                                            <td>
                                                <span className="payment-plan">
                                                    {payment.plan}
                                                </span>
                                            </td>

                                            <td>
                                                ₹
                                                {payment.amount.toLocaleString(
                                                    "en-IN"
                                                )}
                                            </td>

                                            <td>
                                                ₹
                                                {payment.discount.toLocaleString(
                                                    "en-IN"
                                                )}
                                            </td>

                                            <td>
                                                ₹
                                                {payment.gst.toLocaleString(
                                                    "en-IN",
                                                    {
                                                        maximumFractionDigits: 2,
                                                    }
                                                )}
                                            </td>

                                            <td>
                                                <strong className="total-payment">
                                                    ₹
                                                    {payment.totalAmount.toLocaleString(
                                                        "en-IN",
                                                        {
                                                            maximumFractionDigits: 2,
                                                        }
                                                    )}
                                                </strong>
                                            </td>

                                            <td>
                                                <span className="payment-method">
                                                    {payment.paymentMethod}
                                                </span>
                                            </td>

                                            <td>
                                                {payment.gateway}
                                            </td>

                                            <td>
                                                <span className="transaction-id">
                                                    {payment.transactionId}
                                                </span>
                                            </td>

                                            <td>
                                                <div className="payment-date-cell">
                                                    <span>
                                                        {payment.paymentDate}
                                                    </span>
                                                    <small>
                                                        {payment.paymentTime}
                                                    </small>
                                                </div>
                                            </td>

                                            <td>
                                                <span
                                                    className={`payment-status ${payment.status
                                                        .toLowerCase()
                                                        .replace(
                                                            " ",
                                                            "-"
                                                        )}`}
                                                >
                                                    {payment.status}
                                                </span>
                                            </td>

                                            <td>
                                                <button
                                                    className="payment-view-btn"
                                                    title="View Payment"
                                                    onClick={() =>
                                                        setViewPayment(
                                                            payment
                                                        )
                                                    }
                                                >
                                                    <Eye size={17} />
                                                </button>
                                            </td>

                                        </tr>
                                    )
                                )
                            )}

                        </tbody>

                    </table>

                </div>

            </div>

            {/* VIEW PAYMENT MODAL */}

            {viewPayment && (
                <div className="payment-modal-overlay">

                    <div className="payment-view-modal">

                        <div className="payment-modal-header">

                            <div>
                                <h2>Payment Details</h2>

                                <p>
                                    {viewPayment.paymentId}
                                </p>
                            </div>

                            <button
                                onClick={() =>
                                    setViewPayment(null)
                                }
                            >
                                <X size={20} />
                            </button>

                        </div>

                        <div className="payment-receipt-header">

                            <div className="payment-receipt-icon">
                                <CreditCard size={27} />
                            </div>

                            <div>
                                <h3>
                                    ₹
                                    {viewPayment.totalAmount.toLocaleString(
                                        "en-IN",
                                        {
                                            maximumFractionDigits: 2,
                                        }
                                    )}
                                </h3>

                                <span
                                    className={`payment-status ${viewPayment.status
                                        .toLowerCase()
                                        .replace(
                                            " ",
                                            "-"
                                        )}`}
                                >
                                    {viewPayment.status}
                                </span>
                            </div>

                        </div>

                        <div className="payment-detail-section">

                            <h3>Payment Information</h3>

                            <div className="payment-detail-grid">

                                <PaymentInfo
                                    label="Payment ID"
                                    value={
                                        viewPayment.paymentId
                                    }
                                />

                                <PaymentInfo
                                    label="Member ID"
                                    value={
                                        viewPayment.memberId
                                    }
                                />

                                <PaymentInfo
                                    label="Member Name"
                                    value={
                                        viewPayment.memberName
                                    }
                                />

                                <PaymentInfo
                                    label="Mobile Number"
                                    value={
                                        viewPayment.mobile
                                    }
                                />

                                <PaymentInfo
                                    label="Branch"
                                    value={
                                        viewPayment.branch
                                    }
                                />

                                <PaymentInfo
                                    label="Membership Plan"
                                    value={
                                        viewPayment.plan
                                    }
                                />

                                <PaymentInfo
                                    label="Payment Method"
                                    value={
                                        viewPayment.paymentMethod
                                    }
                                />

                                <PaymentInfo
                                    label="Payment Gateway"
                                    value={
                                        viewPayment.gateway
                                    }
                                />

                                <PaymentInfo
                                    label="Transaction ID"
                                    value={
                                        viewPayment.transactionId
                                    }
                                />

                                <PaymentInfo
                                    label="Payment Date"
                                    value={`${viewPayment.paymentDate} ${viewPayment.paymentTime}`}
                                />

                            </div>

                        </div>

                        <div className="payment-detail-section">

                            <h3>Payment Summary</h3>

                            <div className="payment-summary-box">

                                <div>
                                    <span>Plan Amount</span>
                                    <strong>
                                        ₹
                                        {viewPayment.amount.toLocaleString(
                                            "en-IN"
                                        )}
                                    </strong>
                                </div>

                                <div>
                                    <span>Discount</span>
                                    <strong className="discount-value">
                                        - ₹
                                        {viewPayment.discount.toLocaleString(
                                            "en-IN"
                                        )}
                                    </strong>
                                </div>

                                <div>
                                    <span>GST</span>
                                    <strong>
                                        ₹
                                        {viewPayment.gst.toLocaleString(
                                            "en-IN",
                                            {
                                                maximumFractionDigits: 2,
                                            }
                                        )}
                                    </strong>
                                </div>

                                <div className="payment-grand-total">
                                    <span>Total Paid</span>
                                    <strong>
                                        ₹
                                        {viewPayment.totalAmount.toLocaleString(
                                            "en-IN",
                                            {
                                                maximumFractionDigits: 2,
                                            }
                                        )}
                                    </strong>
                                </div>

                            </div>

                        </div>

                        <div className="payment-modal-footer">

                            <button
                                className="secondary-btn"
                                onClick={() =>
                                    setViewPayment(null)
                                }
                            >
                                Close
                            </button>

                        </div>

                    </div>

                </div>
            )}

        </div>
    );
}

function PaymentFilterSelect({
    label,
    value,
    onChange,
    options,
}) {
    return (
        <div className="payment-filter-field">

            <label>{label}</label>

            <div className="payment-select-wrapper">

                <select
                    value={value}
                    onChange={(e) =>
                        onChange(e.target.value)
                    }
                >
                    <option value="">
                        All {label}
                    </option>

                    {options.map((option) => (
                        <option
                            key={option}
                            value={option}
                        >
                            {option}
                        </option>
                    ))}
                </select>

                <ChevronDown size={15} />

            </div>

        </div>
    );
}

function PaymentInfo({ label, value }) {
    return (
        <div className="payment-info-item">
            <span>{label}</span>
            <strong>{value || "-"}</strong>
        </div>
    );
}

export default Payments;